 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en-us-i18n":"lang-en-us-i18n","lang-nl-high-charts":"lang-nl-high-charts","lang-nl-i18n":"lang-nl-i18n"}[chunkId]||chunkId) + "." + {"chunk-2d0a4b7b":"69237c34","chunk-2d0aaa21":"1f5ba84b","chunk-2d0b9e23":"e62f8a6e","chunk-2d0ba4cc":"03616e0d","chunk-2d0c06e4":"421f4c9d","chunk-2d0c19e2":"4c18b738","chunk-2d0c1b3b":"4364b23b","chunk-2d0c49c6":"0fc58d39","chunk-2d0c4ab4":"08164029","chunk-2d0c51f8":"91e7a0dd","chunk-2d0c796d":"85ff26ea","chunk-2d0c9516":"bcdf2824","chunk-2d0cc1eb":"3763f14a","chunk-2d0cc5c9":"ffc4661a","chunk-2d0ccc03":"adac92cb","chunk-2d0ceb60":"c4bb4e6a","chunk-2d0ced91":"e5629f7a","chunk-2d0cef72":"ad995d6d","chunk-2d0cfa98":"c66bdac3","chunk-2d0d2b40":"58551b3e","chunk-2d0d2bbf":"f4de6413","chunk-2d0d38af":"c13390c6","chunk-2d0d3c16":"0caaa505","chunk-2d0d3e55":"af127e9e","chunk-2d0d6f32":"041b909c","chunk-2d0d7df4":"4de0efb9","chunk-2d0d834e":"779035da","chunk-2d0dab46":"101a85d8","chunk-2d0ddb37":"49b6da26","chunk-2d0de2e9":"c90a58d8","chunk-2d0deb36":"568b8b38","chunk-2d0df3e5":"850b7520","chunk-2d0e8e6f":"20d8d3b7","chunk-2d0e9329":"d03e8211","chunk-2d0efccc":"ac866d15","chunk-2d2073a5":"b289753e","chunk-2d2080d6":"d6b774c6","chunk-2d209516":"e6a6ecc4","chunk-2d20f780":"c88515be","chunk-2d210269":"e1a826ac","chunk-2d212c01":"7c8e1495","chunk-2d212c40":"4e30c060","chunk-2d213784":"c1bddd21","chunk-2d217699":"a05471ef","chunk-2d22cae0":"984e4ef3","chunk-2d2382c6":"5a76bee0","chunk-41b4bc34":"053e693e","chunk-82cfb02e":"0ba51829","chunk-a3bf82be":"799607d1","chunk-d6b1ae72":"eca14945","lang-en-us-i18n":"c10c92a1","lang-nl-high-charts":"2ced58f8","lang-nl-i18n":"2f0b3958"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-41b4bc34":1,"chunk-82cfb02e":1,"chunk-a3bf82be":1,"chunk-d6b1ae72":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en-us-i18n":"lang-en-us-i18n","lang-nl-high-charts":"lang-nl-high-charts","lang-nl-i18n":"lang-nl-i18n"}[chunkId]||chunkId) + "." + {"chunk-2d0a4b7b":"31d6cfe0","chunk-2d0aaa21":"31d6cfe0","chunk-2d0b9e23":"31d6cfe0","chunk-2d0ba4cc":"31d6cfe0","chunk-2d0c06e4":"31d6cfe0","chunk-2d0c19e2":"31d6cfe0","chunk-2d0c1b3b":"31d6cfe0","chunk-2d0c49c6":"31d6cfe0","chunk-2d0c4ab4":"31d6cfe0","chunk-2d0c51f8":"31d6cfe0","chunk-2d0c796d":"31d6cfe0","chunk-2d0c9516":"31d6cfe0","chunk-2d0cc1eb":"31d6cfe0","chunk-2d0cc5c9":"31d6cfe0","chunk-2d0ccc03":"31d6cfe0","chunk-2d0ceb60":"31d6cfe0","chunk-2d0ced91":"31d6cfe0","chunk-2d0cef72":"31d6cfe0","chunk-2d0cfa98":"31d6cfe0","chunk-2d0d2b40":"31d6cfe0","chunk-2d0d2bbf":"31d6cfe0","chunk-2d0d38af":"31d6cfe0","chunk-2d0d3c16":"31d6cfe0","chunk-2d0d3e55":"31d6cfe0","chunk-2d0d6f32":"31d6cfe0","chunk-2d0d7df4":"31d6cfe0","chunk-2d0d834e":"31d6cfe0","chunk-2d0dab46":"31d6cfe0","chunk-2d0ddb37":"31d6cfe0","chunk-2d0de2e9":"31d6cfe0","chunk-2d0deb36":"31d6cfe0","chunk-2d0df3e5":"31d6cfe0","chunk-2d0e8e6f":"31d6cfe0","chunk-2d0e9329":"31d6cfe0","chunk-2d0efccc":"31d6cfe0","chunk-2d2073a5":"31d6cfe0","chunk-2d2080d6":"31d6cfe0","chunk-2d209516":"31d6cfe0","chunk-2d20f780":"31d6cfe0","chunk-2d210269":"31d6cfe0","chunk-2d212c01":"31d6cfe0","chunk-2d212c40":"31d6cfe0","chunk-2d213784":"31d6cfe0","chunk-2d217699":"31d6cfe0","chunk-2d22cae0":"31d6cfe0","chunk-2d2382c6":"31d6cfe0","chunk-41b4bc34":"befd4fa7","chunk-82cfb02e":"78e04b51","chunk-a3bf82be":"e58a91d0","chunk-d6b1ae72":"d3eb74a6","lang-en-us-i18n":"31d6cfe0","lang-nl-high-charts":"31d6cfe0","lang-nl-i18n":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
